<template>
  <v-dialog v-model="show" persistent max-width="768">
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        Create Label
      </v-card-title>
      <v-card-text>
        <div class="home-content">
          <v-row>
            <v-col sm="12" md="6" lg="6" cols="12">
              <v-form
                class="create-label"
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <v-row>
                  <v-col>
                    <span class="label-text">Label orientation</span>
                    <div class="input-mb input-box">
                      <v-select
                        dense
                        item-text="title"
                        item-value="value"
                        required
                        class="general-settings-select"
                      />
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span class="label-text">Label settings</span>
                    <div class="settings-row">
                      <div class="settings-row__label">Include Warehouse Name</div>
                      <div class="settings-row__value">
                        <v-switch
                          inset
                          color="rgb(121, 114, 191)"
                        />
                      </div>
                    </div>
                    <div class="settings-row">
                      <div class="settings-row__label">Include Location Code</div>
                      <div class="settings-row__value">
                        <v-switch
                          inset
                          color="rgb(121, 114, 191)"
                        />
                      </div>
                    </div>
                    <div class="settings-row">
                      <div class="settings-row__label">Add Britecheck logo</div>
                      <div class="settings-row__value">
                        <v-switch
                          inset
                          color="rgb(121, 114, 191)"
                        />
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
            <v-col sm="12" md="6" lg="6" cols="12">
              <div class="d-flex justify-center">
                <div class="upload_wrapper wrapper-label">
                  <LabelPDF />
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click.stop="show=false"
          depressed
          class="cancel-btn"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="confirm"
          depressed
          class="save-btn"
        >
          Save as pdf
        </v-btn>
        <v-btn
          @click="confirm"
          depressed
          class="save-btn"
        >
          Print
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LabelPDF from '@/components/locations/LabelPDF'
export default {
  name: 'CreateLabelPopup',
  props: {
    value: Boolean
  },
  components: {
    LabelPDF
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.create-label {
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  padding-right: 30px;
  margin: 30px 0;

  .settings-row {
    max-width: 380px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .settings-row__label {
      padding-right: 30px;
    }
  }
}

.upload_wrapper.wrapper-label {
  margin-top: 15vh;
}
</style>
